<template>
	<UnidadeLayout>
		<div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-min-h-screen">
			<div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-pt-8 tw-pb-4 tw-px-5">
				<div class="tw-flex tw-justify-between tw-items-center tw-max-w-7xl tw-mx-auto">
					<h2 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-slate-800'" class="tw-text-3xl tw-font-bold tw-mb-2">
						Minhas unidades
					</h2>

					<router-link 
						to="/v2/consulta-avancada"
						:class="theme === 'dark'
							? 'tw-bg-slate-800 hover:tw-bg-slate-700 tw-text-white'
							: 'tw-bg-green-500 hover:tw-bg-green-600 tw-text-white'"
						class="tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-3 tw-rounded-lg tw-font-semibold tw-shadow hover:tw-shadow-lg tw-whitespace-nowrap"
						title="Consulta Avançada"
					>
						<svg xmlns="http://www.w3.org/2000/svg" class="tw-w-5 tw-h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
							<path stroke-linecap="round" stroke-linejoin="round" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
						</svg>

						<span>Consulta Avançada</span>
					</router-link>
				</div>
			</div>
			<div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-px-5">
				<div class="tw-max-w-7xl tw-mx-auto">
					<div class="tw-flex tw-justify-center">
						<input
							v-model="filtroUnidade"
							type="text"
							:class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white focus:tw-ring-slate-50 tw-placeholder-gray-300' : 'tw-bg-white tw-text-gray-900 focus:tw-ring-green-500 tw-placeholder-gray-600'"
							class="tw-shadow tw-w-full tw-max-w-md tw-px-4 tw-py-3 tw-rounded-lg focus:tw-outline-none focus:tw-ring-1 focus:tw-border-transparent"
							placeholder="Pesquisar unidade..."
						/>
					</div>
				</div>
			</div>
			<div class="tw-py-8 tw-px-5">
				<div class="tw-max-w-7xl tw-mx-auto">
					<div class="tw-flex tw-flex-wrap tw-justify-center tw-gap-4">
						<CardUnidade
							v-for="unidade in unidadesFiltradas"
							:key="unidade.id"
							:unidade="unidade" />
					</div>
					<div v-if="unidadesFiltradas.length === 0" class="tw-text-center tw-py-12">
						<p class="tw-text-gray-500 tw-text-lg">Nenhuma unidade encontrada</p>
					</div>
				</div>
			</div>
		</div>
	</UnidadeLayout>
</template>
<script>
	import UnidadeLayout from "@/components/layouts/v2/UnidadeLayout.vue";
	import CardUnidade from "@/components/ui/v2/CardUnidade.vue";

	import { ref, onMounted, computed } from "vue";
	import { mapState, useStore } from "vuex";
	import { useToast } from 'vue-toastification';

	export default {
		name: "UnidadesPage",
		components: {
			UnidadeLayout,
			CardUnidade
		},
		computed: {
			...mapState({
				theme: state => state.ui.theme,
			}),
		},
		setup() {
			const store = useStore();
			const unidades = ref([]);
			const toast = useToast();
			const vue_app_name = process.env.VUE_APP_NAME;
			const filtroUnidade = ref("");

			onMounted(async () => {
				try {
					unidades.value = store.state.unidades.unidades;
					if (unidades.value.length == 0) {
						await store.dispatch("unidades/fetchUnidades");
						unidades.value = store.state.unidades.unidades;
					}
				} catch (error) {
					console.error("Erro ao buscar unidades:", error);
					toast.error("Erro ao buscar unidades")
				}
			});

			const unidadesOrdenadas = computed(() => {
				return unidades.value.slice().sort((a, b) => {
					return (a.status === 'inativo' ? 1 : 0) - (b.status === 'inativo' ? 1 : 0);
				});
			});

			const unidadesFiltradas = computed(() => {
				if (!filtroUnidade.value) return unidadesOrdenadas.value;
				return unidadesOrdenadas.value.filter(u =>
					u.nome && u.nome.toLowerCase().includes(filtroUnidade.value.toLowerCase())
				);
			});

			return {
				unidades,
				unidadesOrdenadas,
				unidadesFiltradas,
				filtroUnidade,
				vue_app_name
			};
		},
	};
</script>